import { CustomStringParam, SchemaFilterType } from '@ui/src';

export const agreementsListColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'type',
    label: 'Type',
    sortable: false,
  },
  {
    name: 'version',
    label: 'Version',
    sortable: false,
  },
  {
    name: 'startAt',
    label: 'Date of signing',
    sortable: false,
  },
];

export const agreementsListSchema = {
  type: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  version: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  startAt: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const agreementsListFiltersSchema = [];
